import {
  AirHandlerProductType,
  PTAC_INDOOR_FACE_TYPE,
  PTAC_SYSTEM_TAG,
  SelectedSystemType
} from '@alpinehomeair/common';
import { SystemOptionType } from 'data/types';
import { BuildPtacSelectedSystemParams } from 'utils/ptac-selected-system-types';

export function isPtacSelectedSystem(
  system: Pick<SystemOptionType, 'tags'>
): boolean {
  return system.tags?.includes(PTAC_SYSTEM_TAG) ?? false;
}

export function isPtacIndoorFace(
  product: Pick<AirHandlerProductType, 'type'> | null | undefined
): boolean {
  return product?.type === PTAC_INDOOR_FACE_TYPE;
}

// The SelectedSystemType the compare tray, Add-Ons and the quote run off:
// the server-composed option under the saved quotable system's id. Its
// accessories come from the Add-Ons recommender, not from the save.
export function buildSelectedSystemFromPtacOption({
  option,
  quotableSystem
}: BuildPtacSelectedSystemParams): SelectedSystemType {
  return {
    ...option,
    uniqueId: quotableSystem.uniqueId,
    quoteStatus: 'unsent',
    selectedAccessories: [],
    quotableAccessories: [],
    accessoriesCompleted: [],
    accessoriesNotNeeded: [],
    noAccessoriesNeeded: true
  };
}
